module.exports = __webpack_public_path__ + "img/9.f21f46d4.jpg";